import { Component, Host, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { distinctUntilChanged, filter, map, pluck, shareReplay, switchMap, tap } from 'rxjs/operators';

import { AdminReportsService, IVideoSummary } from 'rev-portal/admin/reports/AdminReports.Service';
import { AnalyticsService } from 'rev-shared/analytics/Analytics.Service';
import { IMediaFeatures } from 'rev-shared/media/IMediaFeatures';

import styles from 'rev-portal/admin/reports/AdminReports.module.less';

interface IKpiData {
	avgViewingDurationSecs: number;
	completionRate: number;
	totalVideoViews: number;
	uniqueViewers: number;
}

@Component({
	selector: 'video-analytics',
	templateUrl: './VideoAnalytics.Component.html'
})
export class VideoAnalyticsComponent implements OnInit {
	@Input() public accountId: string;
	@Input() public mediaFeatures: IMediaFeatures;

	private videoSummary$: Observable<IVideoSummary>;

	public readonly styles = styles;
	public readonly pageSize = 50;
	public readonly topVideosCount = 50;

	public kpis$: Observable<IKpiData>;
	public topHitsDownloadUrl: string;
	public viewsByDay$: Observable<any[]>;
	public viewsDownloadUrl: string;

	constructor(
		@Host() public AnalyticsService: AnalyticsService,
		public AdminReportsService: AdminReportsService
	) {}

	public ngOnInit(): void {
		this.videoSummary$ = this.AnalyticsService.dataFetchContext$
			.pipe(
				filter(context => !!context?.startDate),
				distinctUntilChanged(),
				tap(context => this.assignDownloadUrls(context)),
				switchMap(context => this.AdminReportsService.getVideosActivitySummary(this.accountId, context)),
				shareReplay({ bufferSize: 1, refCount: true })
			);

		this.kpis$ = this.videoSummary$
			.pipe(
				map(val => ({
					avgViewingDurationSecs: val.avgViewingDurationSecs,
					completionRate: val.completionRate,
					totalVideoViews: val.totalVideoViews,
					uniqueViewers: val.uniqueViewers
				}))
			);

		this.viewsByDay$ = this.videoSummary$
			.pipe(
				pluck('viewsByDay')
			);
	}

	private assignDownloadUrls(context: {startDate: string, endDate: string}): void {
		this.topHitsDownloadUrl = `/reports/account/${this.accountId}/videos/top-hits/${this.topVideosCount}/csv?startDate=${context.startDate}&endDate=${context.endDate}`;
		this.viewsDownloadUrl = `/reports/account/${this.accountId}/videos/user-sessions/csv?startDate=${context.startDate}&endDate=${context.endDate}`;
	}
}
